module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('order-list', {
    attrs: {
      "orders": _vm.newOrders
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61c6495e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/views/orders/NewOrders.vue
// module id = 542
// module chunks = 0